import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-searchinput', 'clear', 'Очистить поле');
Labels.set('ui-searchinput', 'search', 'Поиск');
